<template>
  <div class="payment-info-item">
    <h4 class="payment-info-item__type">{{ ccNo }}</h4>
    <span class="lg: text-lg">{{ $t('common.cardExpired', { month, year }) }}</span>
  </div>
</template>

<script>
export default {
  props: {
    cardNumber: {
      type: String,
      required: false,
      default: () => '',
    },
    month: {
      type: [Number, String],
      required: false,
      default: null,
    },
    year: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  computed: {
    ccNo() {
      return this.getCcNo()
    },
  },
  methods: {
    isSp() {
      const mediaQuery = window.matchMedia('(max-width: 1024px)')
      if (mediaQuery.matches) {
        return true
      } else {
        return false
      }
    },
    getCcNo() {
      let msg = '下4桁 '
      const ccNo = this.cardNumber ? this.cardNumber : ''
      if (this.isSp()) {
        if (ccNo.length > 4) {
          msg += ccNo.slice(-4)
          return msg
        }
      }
      return ccNo
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/payment-info-item.scss';
</style>
